import React, { useEffect, useState } from 'react';

import api from '@/Services/api';
import Map from '@/Components/Map';
import LoadPage from '@/Components/LoadPage';

import { Container, Subtitle, Area } from './styles';

// O backend agora envia as coordenadas dos polígonos em [lng, lat]; o Leaflet
// espera [lat, lng]. Inverte cada par de coordenadas, preservando a estrutura
// de anéis do polígono.
function toLatLng(geo) {
  const swapPair = (pair) => [pair[1], pair[0]];
  return geo.map((ring) => ring.map(swapPair));
}

function MyAreas(props) {
  const [areas, setAreas] = useState([]);
  const [center, setCenter] = useState([0, 0]);

  const token = localStorage.getItem('token');
  const search = props.location.search;

  useEffect(() => {
    api
      .get(`/Mapas/Minhas-Areas${search}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const parsed = response.data.map((area) => ({
          ...area,
          geo: toLatLng(area.geo),
        }));

        setCenter(parsed[0].geo[0][0]);
        setAreas(parsed);
      });

    //eslint-disable-next-line
  }, [token]);

  if (areas.length === 0) {
    return <LoadPage />;
  }

  return (
    <Container>
      <Map props={{ zoom: 15, center }}>
        {areas.map((area) => (
          <Area key={String(area.subarea)} positions={area.geo}>
            <Subtitle>{area.subarea}</Subtitle>
          </Area>
        ))}
      </Map>
    </Container>
  );
}

export default MyAreas;
